<template>
  <OrderTrace :admin-view="false" :visitor-view="true"/>
</template>

<script>
import OrderTrace from "@/components/OrderTrace/OrderTrace";

export default {
  name: "MyOrderListDesktop",
  components: {OrderTrace}
}
</script>

<style scoped>

</style>